import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { adminGetInvoiceBilling } from '../../../../../../api'
import InvoiceOrderItems from '../../../../../Shared/Order/Items'

class InvoiceBill extends Component {

  constructor (props) {
    super(props)
    this.state = {
      billing: null,
      loading: false,
      error: null,
      orderAdditionalData: { items: props.orderItems }
    }
    this.abortController = null
  }

  componentDidMount () {
    this.loadInvoiceBilling()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (this.props.orderId !== prevProps.orderId) {
      this.setState({ billing: null }, () => {
        this.loadInvoiceBilling()
      })
    }
    if (this.props.orderItems !== prevProps.orderItems) {
      this.setState({ orderAdditionalData: { items: prevProps.orderItems } })
    }
  }

  componentWillUnmount () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
  }

  loadInvoiceBilling () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    this.setState({ loading: true, error: null }, () => {
      adminGetInvoiceBilling(this.props.invoiceId, this.abortController).fetchPromise.then((response) => {
        this.setState({ loading: false, billing: response })
      }).catch(() => {
        this.setState({ loading: false, error: 'Failed' })
      })
    })
  }

  render () {
    return (
      <div>
        {this.state.billing !== null &&
        <InvoiceOrderItems bill={this.state.billing} orderAdditionalData={this.state.orderAdditionalData}
                           showFollowUp={false}/>
        }
      </div>
    )
  }
}

InvoiceBill.propTypes = {
  invoiceId: PropTypes.number.isRequired,
  orderItems: PropTypes.object.isRequired
}

export default withTranslation()(InvoiceBill)
